import { FsLprFleetRead } from '../models';
import { LPRResultsFacets } from './common/lpr-results-facets';

export interface FsLprFleetResults {
  data: FsLprFleetRead[];
  metadata: {
    total: number;
    totalQueryResults: number;
    facets?: LPRResultsFacets;
  };
}
